import { tabsAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, theme } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const tabsTheme = theme.components?.Tabs;

export const styleConfig = defineMultiStyleConfig({
  ...tabsTheme,
  baseStyle: definePartsStyle({
    root: {},
    tablist: {
      borderBottom: '1px solid',
      borderColor: 'grey.100',
    },
    tab: {
      fontWeight: 'bold',
      color: 'grey.600',
      _selected: { color: 'blue.500' },
      _disabled: { color: 'grey.300', cursor: 'not-allowed' },
      _focusVisible: {
        outline: 0,
        boxShadow: '0 0 0 1px white, 0 0 0 3px #6691FF',
      },
    },
    indicator: {
      height: '2px',
      mt: '-2px',
      bg: 'blue.500',
    },
  }),
});
